import API from "../../../helpers/devApi";

const API_ENDPOINTS = "/hrms_job_description";
// const API_ENDPOINTS = "http://localhost:6003/api/v1/hrms_job_description";

// Create  new Requisiton
export function createJobDescription(data) {
  return API.post(API_ENDPOINTS, data);
}

export function getJobDescriptionList() {
  return API.get(`${API_ENDPOINTS}`);
}

export function getJobDescriptionDropdown() {
  return API.get(`${API_ENDPOINTS}/dropdown`);
}

export function getAreaOfInvolvement() {
  return API.get(`${API_ENDPOINTS}/get/list/area/of/involvment`);
}

export function getAreaOfInvolvementLabel(cost_center_id) {
  return API.get(
    `${API_ENDPOINTS}/get/list/area/of/involvment/parent/${cost_center_id}`
  );
}

export function getJobDescriptionListByFilter(payload) {
  return API.post(`${API_ENDPOINTS}/get/all`, payload);
}

export function getCertificationList() {
  return API.get(`/hrms_certification`);
}

export function getSkillList() {
  return API.get(`/hrms_skill`);
}

export function getEmployeeCategoryList() {
  return API.get(`/hrms_employee_categories`);
}

export function getJobDescriptionQuestionTypeList(requisition_id) {
  return API.get(
    `/hrms_question_type${
      requisition_id ? "?requisition_id=" + requisition_id : ""
    }`
  );
}

export function getQuestionTypeListByJob(job_id) {
  return API.get(`/hrms_interview_schedule/interview-type/${job_id}`);
}

export function getAllJobDescriptionList() {
  return API.get(`${API_ENDPOINTS}/list`);
}

export function getAllList(payload) {
  return API.post(`/hrms_job/list/by/status`, payload);
}

export function getOneJobDescription(id) {
  return API.get(`${API_ENDPOINTS}/${id}`);
}

export function getQuestionsByJobDescription(id, type_id) {
  return API.get(`hrms_jd_question/grtByJd/${id}/${type_id}`);
}

export function getQuestionsMarkByApplicant(id, jd_id, type_id) {
  return API.get(
    `/hrms_applicant_assessment/getInfoByApplicantNJd/${id}/${jd_id}/${type_id}`
  );
}

// UPDATE Requisiton by ID
export function updateJobDescription(data, id) {
  return API.patch(`${API_ENDPOINTS}/${id}`, data);
}

// DELETE  Requisiton information from server
export function deleteJobDescription(id) {
  return API.delete(`${API_ENDPOINTS}/${id}`);
}

export function getGeneralDutiesBasedOnDesignation(id) {
  return API.get(`/hrms_shift_mapping/getShiftInfoByDesignation/${id}`);
}

// Get Assessments questions
export function getAssessmentQuestionsByJobDescription(id) {
  return API.get(`hrms_jd_assesment_question/byJobDescId/${id}`);
}
